module.exports = __webpack_public_path__ + "img/products_2.c0a521eb.png";